var _title, _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconSetCondition = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 45 35",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Set a Condition icon")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Query-Filtering",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Notes",
  transform: "translate(-396.000000, -451.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Set-a-Condition-default",
  transform: "translate(363.000000, 450.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Set-a-Condition-icon",
  transform: "translate(31.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(2.882353, 1.440000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#D1D3D4",
  x: 0,
  y: 0,
  width: 43.2352941,
  height: 5.76,
  rx: 2.88
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#D1D3D4",
  x: 0,
  y: 28.08,
  width: 43.2352941,
  height: 5.76,
  rx: 2.88
}), /*#__PURE__*/React.createElement("g", {
  id: "Group-8",
  transform: "translate(0.000000, 7.920000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#81848F",
  x: 0,
  y: 1.44,
  width: 43.2352941,
  height: 5.76,
  rx: 2.88
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  stroke: "#F7F8F8",
  strokeWidth: 1.44,
  x: 7.92588235,
  y: 0.72,
  width: 12.9717647,
  height: 7.2,
  rx: 3.6
})), /*#__PURE__*/React.createElement("g", {
  id: "Group-7",
  transform: "translate(0.000000, 17.280000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#81848F",
  x: 0,
  y: 1.44,
  width: 43.2352941,
  height: 5.76,
  rx: 2.88
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  stroke: "#F7F8F8",
  strokeWidth: 1.44,
  x: 16.5729412,
  y: 0.72,
  width: 12.9717647,
  height: 7.2,
  rx: 3.6
})))))))));
export default SvgIconSetCondition;